import { createFileRoute } from "@tanstack/react-router";
import { CreateReceptionPage } from "@/features/achats/components/receptions/CreateReceptionPage";

export const Route = createFileRoute("/_app/achats/receptions/create")({
  staticData: {
    title: "Nouveau bon de réception",
    showInBreadcrumb: true,
  },
  component: CreateReceptionPage,
});
